import { getRandomSampleFromArray } from '@belong/common';
import { GMB_LINKS } from './constants';

/** One entry of `GMB_LINKS` — a Belong office's Google Business listing. */
export type GoogleMyBusinessProfile = (typeof GMB_LINKS)[string];

type GetGoogleMyBusinessProfileParams = {
  city: string;
  regionId: number;
};

export function getGoogleMyBusinessProfile({
  city,
  regionId,
}: GetGoogleMyBusinessProfileParams) {
  const cityGoogleMyBusinessProfile = GMB_LINKS[city];

  if (cityGoogleMyBusinessProfile) {
    return cityGoogleMyBusinessProfile;
  }

  const regionGoogleMyBusinessProfiles = Object.values(GMB_LINKS).filter(
    (googleMyBusinessProfile) => googleMyBusinessProfile.region === regionId,
  );

  if (regionGoogleMyBusinessProfiles.length > 0) {
    const randomRegionGoogleMyBusinessProfile = getRandomSampleFromArray({
      array: regionGoogleMyBusinessProfiles,
      sampleSize: 1,
    });

    return randomRegionGoogleMyBusinessProfile[0];
  }

  return null;
}
